export const DataUpdatePartialSolicitud = {
    "codigo": 0,
	"idSolicitud": 0,
	"llaveSeguridad": "",
	"respuesta": null
}